import { Component } from '@angular/core';

@Component({
	selector: 'app-malicious-user-page',
	templateUrl: './malicious-user-page.component.html',
	standalone: false,
})
export class MaliciousUserPageComponent {}
